import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'; // Import Navigate from react-router-dom
import Layout from '../Layout';

// Import routes and private route
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import PrivateRoute from './PrivateRoute'; // Import the PrivateRoute component

const Index = () => {
  return (
    <Routes>
      {/* Public routes */}
      {publicRoutes.map((route, idx) => (
        <Route
          path={route.path}
          element={route.component}
          key={idx}
        />
      ))}

      {/* Protected routes */}
      {authProtectedRoutes.map((route, idx) => (
        <Route
          path={route.path}
          element={
            <PrivateRoute>
              <Layout>{route.component}</Layout>
            </PrivateRoute>
          }
          key={idx}
        />
      ))}

      {/* Fallback route if no match */}
      <Route path="*" element={<Navigate to="/signin" />} />
    </Routes>
  );
};

export default Index;
